export enum DateRanges {
  WEEK = "week",
  MONTH = "month",
  THREE_MONTHS = "three_months",
  SIX_MONTHS = "six_months",
  YEAR = "year"
}
